import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=0b1a244e&scoped=true"
import script from "./baseForm.vue?vue&type=script&lang=js"
export * from "./baseForm.vue?vue&type=script&lang=js"
import style0 from "./baseForm.vue?vue&type=style&index=0&id=0b1a244e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a244e",
  null
  
)

export default component.exports